<template>
  <div>
    <!-- <v-container> -->
    <div id="app ">
      <div style="display: flex; justify-content:space-between ;">
        <!-- <v-row> -->
        <!-- <v-col cols="11"> -->
        <Breadcrumb class="row justify-content-center mt-4" />
        <!-- </v-col> -->
        <!-- <v-col cols="1" > -->
        <span v-if="showLoader"><LoaderProgress></LoaderProgress></span>
        <!-- </v-col> -->
        <!-- </v-row> -->
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="200">
      <v-card>
        <!-- <v-card-text class="cardText">Drill down for further analysis. Choose the relevant option.</v-card-text> -->
        <v-card-actions class="cardButtonsDiv">
          <!-- <router-link color="primary"  to="/multipleOEE" >OEE Dashboard</router-link> -->
          <!-- <router-link color="primary" to="/EnergyMonitoring">Energy Dashboard</router-link>  -->
          <v-btn
            v-for="(pages, index) in single_machine_page_name"
            :key="index"
            color="primary"
            small
            class="button"
            @click="navigateTo(single_machine_page_name[index].route_address)"
          >
            {{ pages.page_name }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row class="mt-0 border-bottom">
      <v-col>
        <!-- <DateRange></DateRange> -->
        <newFiltercomp
          style="margin-right: 5px !important"
          :filter_data="param"
        />
        <buttonNew class="button" style="margin-right: 5px !important" />
      </v-col>
    </v-row>
    <v-col
      v-if="oeeData"
      cols="12"
      style="display: flex; justify-content: space-around; flex-wrap: wrap;"
    >
      <v-col
        v-bind:key="apq.id"
        v-for="apq in oeeData"
        cols="12"
        lg="4"
        md="6"
        sm="12"
        class="mt-4"
      >
        <!-- <v-col
            cols="12"
            lg="4"
            md="6"
            sm="12"
            class="mt-8 d-flex"
            style="display: flex;"
          > -->
        <a v-on:click="openDialog(apq.id)">
          <plantSingleCard v-bind:apq="apq" />
        </a>
        <!-- </v-col> -->
      </v-col>
      <h1 style="margin-top:10px;" v-if="oeeData.length == 0 && !showLoader">
        No Data Available
      </h1>
    </v-col>
    <!-- </v-container> -->
  </div>
</template>

<script>
// import SingleMachine from "../components/singleOEE";
import Breadcrumb from "../components/breadcrumbs.vue";
// import LoaderProgress from '../components/progressLoader.vue'

import plantSingleCard from "../components/PlantSingleCard";
// import DateRange from "../components/dateFilter";
import newFiltercomp from "../components/newFiltercomp.vue";
import axios from "axios";
// import constants from "../constants";
import router from "../router";
import LoaderProgress from "../components/progressLoader";

export default {
  name: "plantMonitoringDashboard",
  components: {
    // DateRange,
    newFiltercomp,
    plantSingleCard,
    Breadcrumb,
    LoaderProgress,
  },
  data: () => ({
    param: {
      machine: false,
      time_period: true,
      check: false,
      aggfunc: false,
      date: new Date().toISOString().slice(0, 10),
      date_2: new Date().toISOString().slice(0, 10),
    },

    oeeData: [0],
    showLoader: false,
    dialog: false,
    filter_data: [],
    drill_down_pages: [],
    single_machine_page_name: "",
    current_machine: "",
  }),
  mounted() {
    this.showLoader = false;

    // this.getOEE(null, null, true);
  },
  methods: {
    openDialog(machine_id) {
      this.dialog = true;
      this.current_machine = machine_id;
      console.log("open dailouge", machine_id, this.current_machine);
      for (let index = 0; index < this.drill_down_pages.length; index++) {
        if (machine_id === this.drill_down_pages[index].machine_id) {
          this.single_machine_page_name = this.drill_down_pages[
            index
          ].page_name_list;
          console.log("open", this.drill_down_pages[index].page_name_list);
        }
      }
    },
    navigateTo(address) {
      console.log(
        "redirect to multiple ",
        this.start_date,
        this.end_date,
        address
      );
      this.$router.push({
        name: `${address}`,
        params: {
          start_date: this.start_date,
          end_date: this.end_date,
          machine_id: this.current_machine,
          route_path: `${address}`,
        },
      });
    },
    getTimeInHours: (mins) => {
      let hours = Math.floor(mins / 60);
      let minutes = mins % 60;
      return `${hours}hrs ${minutes}mins`;
    },

    datePicked(x) {
      // console.log(">>>> [datePicked] in OEE", x);
      const start = parseInt(x[0]);
      const end = parseInt(x[1]);
      console.log(
        "human readable format: ",
        new Date(start * 1000),
        new Date(end * 1000)
      );
      this.searchNew(x[0], x[1]);
    },
    addSelectedMachineToSession(machineId) {
      sessionStorage.setItem("machineID", machineId);
    },
    //
    searchNew: function(machine_id, startDate, endDate, show, grp_show, check) {
      console.log("Checking show", show, grp_show);

      this.start_date = startDate;
      this.end_date = endDate;
      console.log(
        "start and end date while calling searchNew",
        this.start_date,
        this.end_date,
        check
      );
      // document.querySelector("#warningAlert").style.display = "none";
      this.machine_id_Selected = machine_id;

      let params = "";
      this.showLoader = true;
      // document.querySelector("#loaderStyle").style.display = "block";
      console.log("default value", this.start_date);
      if (this.start_date == "") {
        params = `?machine=${machine_id}`;
      } else {
        params = `?machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      }

      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getPlantDashboard${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      sessionStorage["loadervalue"] = true;

      this.noteLastAPICallTime();
      // sessionStorage.setItem("loadervalue",true);
      // this.$session.set("username", "");

      axios(config)
        .then((response) => {
          // sessionStorage["loadervalue"]="";
          console.log(
            "checking value in plant",
            sessionStorage.getItem("loadervalue")
          );
          // sessionStorage["loadervalue"]="";
          // sessionStorage["loadervalue"]="";

          console.log(
            "checking value in plant",
            sessionStorage.getItem("loadervalue")
          );

          this.showLoader = false;
          let data = response.data.data;
          console.log("checking response", data);
          for (let index = 0; index < data.length; index++) {
            this.drill_down_pages.push({
              machine_id: data[index].machine_id,
              page_name_list: data[index].pages_for_machine,
            });
          }
          console.log("dill down pages", this.drill_down_pages);
          let dataKeys = [];
          Object.entries(data).forEach(([key, value]) => {
            console.log(key, value);
            dataKeys.push(key);
          });
          console.log("keys lsit to evalutaiton", dataKeys);
          let structuredAPQ = data.map((e) => {
            let id = e.machine_id;
            let machine_name = e.machine_name;

            let totalUpTime = this.getTimeInHours(e.total_up_time);

            // totalUpTime = totalUpTime.toFixed(2);
            let contentName = e.status;
            let cardColor = "success";

            if (e.status == "ON") {
              cardColor = "success";
            } else if (e.status == "OFF") {
              cardColor = "error";
            } else if (e.status == "IDLE") {
              cardColor = "warning";
            }
            let plugState = {
              headerName: "Plug State",
              contentName: contentName,
            };
            // console.log("checking plug state",plugState);
            let availability = e.availability * 100;
            availability = availability.toFixed(2);
            let performance = e.performance * 100;
            performance = performance.toFixed(2);
            let quality = e.quality * 100;
            quality = quality.toFixed(2);
            let oee = (availability * performance * quality) / (100 * 100);
            oee = oee.toFixed(0);
            let powerConsumption = e.total_kwh;
            let productionQty = e.total_production_quantity;
            let singleMachineOEE = {
              id,
              machine_name,
              totalUpTime,
              plugState,
              cardColor,
              powerConsumption,
              productionQty,
              oee,
            };
            return singleMachineOEE;
          });

          this.oeeData = structuredAPQ || [];
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    intervalFetchData: function(
      machine_id,
      startDate,
      endDate,
      show,
      grp_show,
      check
    ) {
      //console.log("inside interval fetchdata", startDate, endDate);
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      //console.log("machine id", machine_id);
      let count = 0;

      this.searchNew(
        this.machine_id_Selected,
        startDate,
        endDate,
        show,
        grp_show,
        check
      );
      //console.log("inside set interval");
      //console.log("present machine id", this.machine_id_Selected);

      // this.assignparam(this.machine_id_Selected);

      // this.searchNew(
      //   this.machine_id_Selected,
      //   this.start_date,
      //   this.end_date,show,grp_show
      // );
      count += 1;
      console.log("checking count ", count, "timestamp", new Date());
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 767px) {
}
.h2Style {
  color: #000000;
  padding: 12px;
}
.button {
  text-transform: none !important;
  margin: 10px !important;
  width: 120px;
}
/* .cardText{
  padding:10px !important ; 
  text-align: center !important;
} */
.cardButtonsDiv {
  flex-flow: column wrap;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
